import { gHelpRef } from "../constants";
import { LaunchHelpCode } from "./LaunchHelpCode";

export function LaunchHelpLookup(lookup) {
  var helpCode = gHelpRef[lookup];
  LaunchHelpCode(helpCode);
}
